import { render, staticRenderFns } from "./LinkEmailPopup.vue?vue&type=template&id=707d7b98"
import script from "./LinkEmailPopup.vue?vue&type=script&lang=js"
export * from "./LinkEmailPopup.vue?vue&type=script&lang=js"
import style0 from "./LinkEmailPopup.vue?vue&type=style&index=0&id=707d7b98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports